import { workflowStage } from "../EvidenceDetails/Workflow/start";

export enum infoType {
    meshHist = "mesh_hist"
}

export function getInfo(domain: string) {
    switch (domain) {
        case infoType.meshHist:
            return {
                type: infoType.meshHist,
                image: require("../../assets/info/mesh_hist.png"),
                title: "MeSH Children Histogram",
                info: "This chart reveals how non-zero M_Scores are distributed across all children in a subtree, spanning all levels down to the leaves. Spot a cluster of children with high M_Scores? That’s your cue—this branch might hold valuable details worth exploring further!"
            }
        case workflowStage.geneContribution:
            return {
                type: workflowStage.geneContribution,
                image: require("../../assets/info/gene_contrib.png"),
                title: "Gene Contribution Analysis",
                info: "Curious about how each gene plays a role in different data streams? This stage lets you explore gene contributions to the quantitative evidence collected from various sources. Since these data streams are diverse, their evidence isn’t directly comparable—but the links show the proportion of evidence each gene contributes within its respective stream.\n\nWant to dive deeper? Click on a link to uncover the qualitative evidence behind it and gain richer insights into the data driving these connections!"
            }
        case workflowStage.saturation:
            return {
                type: workflowStage.saturation,
                image: require("../../assets/info/saturation.png"),
                title: "Evidence Saturation",
                info: "Not all data streams have the same impact! In this stage, we apply a saturation function to balance the impact of different evidence sources. The α parameter determines how quickly the evidence reaches its maximum contribution, shaping how raw data is adjusted before moving forward.\n\nWant to see it in action? Click on a node to visualize the saturation function and reveal how the input transforms into the output."
            }
        case workflowStage.weightedScores:
            return {
                type: workflowStage.weightedScores,
                image: require("../../assets/info/weighing.png"),
                title: "Weighted Score Calculation",
                info: "In this stage, we assign weights to reflect the importance of each source. Stronger evidence has a greater influence, ensuring a balanced and meaningful contribution.\n\nJust sit back and watch as the weighted values take shape."
            }
        case workflowStage.weightedSum:
            return {
                type: workflowStage.weightedScores,
                image: require("../../assets/info/score.png"),
                title: "Final Score Aggregation",
                info: "This is where everything comes together! In this stage, we calculate the final score by summing up the weighted contributions from all data streams. Here, both positive and negative contributions are clearly separated, allowing you to see how each factor influences the final outcome.\n\nJust let the numbers do the work as the final score is revealed!"
            }

        default:
            break;
    }
}